<div class="wrapper cv-dialog-form organization-container">
	<div class="row">
		<div class="col-sm-12">
			<cv-dropdown
				[required]="true"
				[label]="'Source'"
				[placeholder]="'Select an Origin'"
				[selectedValue]="config.origin"
				[options]="source"
				(valuesChange)="onSourceSelected($event)"
			>
			</cv-dropdown>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-12">
			<cv-dropdown
				#statusMilestone
				[required]="true"
				[label]="'Status'"
				[placeholder]="'Select an Status'"
				[selectedValue]="config.status"
				[clearSelection]="!config.origin"
				[options]="status"
				(valuesChange)="onStatusSelected($event)"
			>
			</cv-dropdown>
		</div>
	</div>
	<div class="row">
		<div class="col-sm-12">
			<cv-input
				(controlKeyup)="config.message = $event.value; setIsFormValid()"
				[value]="config.message"
				[label]="'Message'"
				[type]="'textarea'"
				[name]="'Message'"
				[minlength]="1"
				[required]="true"
			>
			</cv-input>
		</div>
	</div>
	<div class="row">
		<cv-switch
			[class]="'cv-switch-blue'"
			[checked]="config.sendConfirmationToOrigin"
			[size]="'sm'"
			(valueChange)="onSendConfirmationToOrigin($event)"
		></cv-switch>
		<span>Send confirmation to Origin</span>
	</div>
</div>
